import { useParams } from "react-router-dom";
import QuestionBuilder from "./QuestionBuilder";

const StudyFormBuilder = () => {
  const { id: studyId, formId } = useParams();
  return (
    <QuestionBuilder
      studyId={studyId || ""}
      formId={formId || ""}
      type="study"
    />
  );
};

export default StudyFormBuilder;
